import { Nullable } from "util/extendedTypes";

export enum AssertionType {
  CanNotUseOnlineJourney = "canNotUseOnlineJourney",
  AuthorisedToActAndNotMinor = "authorisedToActAndNotMinor",
  ConsentToUsePAYG = "consentToUsePAYG",
  BusinessCeasedTrading = "businessCeasedTrading",
  DiscussPAYGOptions = "discussPAYGOptions",
  DiscussFinancialDifficulty = "discussFinancialDifficulty",
  DiscussAlternativeOptions = "discussAlternativeOptions",
}

export type AssertionAnswer = {
  type: AssertionType;
  answer: Nullable<boolean>;
  expected: boolean;
};

export type AssertionAnswers = {
  answers: AssertionAnswer[];
};

export const defaultPreAssertionAnswers = (): AssertionAnswers => {
  return {
    answers: [
      {
        type: AssertionType.CanNotUseOnlineJourney,
        answer: null,
        expected: false,
      },
      {
        type: AssertionType.AuthorisedToActAndNotMinor,
        answer: null,
        expected: true,
      },
      { type: AssertionType.ConsentToUsePAYG, answer: null, expected: true },
      {
        type: AssertionType.BusinessCeasedTrading,
        answer: null,
        expected: false,
      },
    ],
  };
};

export type AssertionItem = {
  attestationKey: AssertionType;
  attestationValue: boolean;
};

export const toAssertionType = (type: string): AssertionType => {
  const enumValues = Object.keys(AssertionType).map(
    (k) => AssertionType[k as keyof typeof AssertionType]
  );
  if (enumValues.findIndex((v) => v === type) >= 0) {
    return type as AssertionType;
  }
  throw new Error(`Unknown AttestationKey type ${type}`);
};

export const defaultPostAttestationAnswers = (): AssertionAnswers => {
  return {
    answers: [
      {
        type: AssertionType.DiscussFinancialDifficulty,
        answer: null,
        expected: false,
      },
      {
        type: AssertionType.DiscussPAYGOptions,
        answer: null,
        expected: false,
      },
      {
        type: AssertionType.DiscussAlternativeOptions,
        answer: null,
        expected: false,
      },
    ],
  };
};

export const defaultPostAttestation = (): PostAttestation => {
  return {
    hardStoppedOnUI: false,
    answers: defaultPostAttestationAnswers().answers,
  };
};

export type PostAttestation = {
  hardStoppedOnUI: boolean;
} & AssertionAnswers;
